import pptxgen from 'pptxgenjs';

import wmLogo from '../../assets/wm-Logo-dark.svg';
import { ControlSlideData } from '../../Types/dealGPT';
import { BenchmarkSlideData, generateBenchmarkSlide } from './benchmarkSlide';
import { generateControlSlide } from './cybersecurity/controlSlide';

const setupMasterSlide = (pres: pptxgen) => {
  pres.defineSlideMaster({
    title: 'MASTER_SLIDE',
    background: { color: 'FFFFFF' },
    objects: [
      { rect: { x: 0, y: 4.925, w: '100%', h: 0.7, fill: { color: 'E7EEF8' } } },
      { image: { path: wmLogo, x: 0.3, y: 5.11, w: 1.3, h: 0.3 } },
      {
        text: {
          text: `© ${new Date().getFullYear()} West Monroe Partners  |  Reproduction and/or distribution without West Monroe Partners' prior consent is prohibited`,
          options: {
            x: 3.2,
            y: 4.85,
            w: 6.0,
            h: 0.8,
            align: 'right',
            valign: 'middle',
            fontSize: 7.5,
            color: '484481',
            fontFace: 'Arial',
            bold: false,
          },
        },
      },
    ],
  });
};

export const generateControlPresentation = async (scope: string, data: ControlSlideData) => {
  const pres = new pptxgen();
  setupMasterSlide(pres);
  generateControlSlide(pres, scope, data, 1);
  await pres.writeFile({ fileName: `${scope} Control.pptx` });
};

export const generateBenchmarkPresentation = async (
  scope: string,
  benchmarkDate: Date,
  data: BenchmarkSlideData[]
) => {
  const pres = new pptxgen();
  setupMasterSlide(pres);
  generateBenchmarkSlide(pres, scope, benchmarkDate, data, 1);

  await pres.writeFile({ fileName: `${scope} Capabilities.pptx` });
};
